const appInstallationStatus = {
    pending: 'Pending',
    installed: 'Installed',
    uninstalled: 'Uninstalled',
    revoked: 'Revoked',
};

export default appInstallationStatus;
